// Human-readable byte sizes
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

// Human-readable speed
export function formatSpeed(bytesPerSec: number): string {
  return `${formatBytes(bytesPerSec)}/s`;
}

// Human-readable ETA
export function formatEta(seconds: number): string {
  if (!isFinite(seconds) || seconds <= 0) return '';
  if (seconds < 60) return `~${Math.ceil(seconds)}s left`;
  if (seconds < 3600) return `~${Math.ceil(seconds / 60)}m left`;
  return `~${Math.ceil(seconds / 3600)}h left`;
}

// Format a date/time string to a short readable form
export function formatDate(iso: string): string {
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

// File type icon based on extension
export function fileTypeIcon(filename: string): string {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  const iconMap: Record<string, string> = {
    pdf: '📄',
    csv: '📊',
    xlsx: '📊',
    xls: '📊',
    xml: '📝',
    json: '📝',
    txt: '📄',
    zip: '📦',
    gz: '📦',
    tar: '📦',
    hl7: '🏥',
    ccd: '🏥',
    ccda: '🏥',
    fhir: '🏥',
    ndjson: '📝',
    tsv: '📊',
    doc: '📄',
    docx: '📄',
    jpg: '🖼️',
    jpeg: '🖼️',
    png: '🖼️',
  };
  return iconMap[ext] ?? '📁';
}
